import React, { useState, useEffect } from 'react';

const useBreakpoints = () => {
    const [currentBreakpoint, setCurrentBreakpoint] = useState(getBreakPoint());

    useEffect(() => {
        window.addEventListener('resize', windowUpdated);

        windowUpdated();

        return () => window.removeEventListener('resize', windowUpdated);
    }, []);

    function windowUpdated() {
        setCurrentBreakpoint(getBreakPoint());
    }

    function getBreakPoint() {
        if (window.innerWidth < 576) {
            return 'xs';
        } else if (window.innerWidth < 768) {
            return 'sm';
        } else if (window.innerWidth < 992) {
            return 'md';
        } else if (window.innerWidth < 1200) {
            return 'lg';
        } else {
            return 'xl';
        }
    }

    const xs = 'xs sm md lg xl';
    const sm = 'sm md lg xl';
    const md = 'md lg xl';
    const lg = 'lg xl';

    function isBreakpoint(breakpoint) {
        switch (breakpoint) {
            case 'xs':
                return xs.indexOf(currentBreakpoint) > -1;
            case 'sm':
                return sm.indexOf(currentBreakpoint) > -1;
            case 'md':
                return md.indexOf(currentBreakpoint) > -1;
            case 'lg':
                return lg.indexOf(currentBreakpoint) > -1;
            default:
                return true;
        }
    }

    return {
        currentBreakpoint: currentBreakpoint,
        isBreakpoint: isBreakpoint
    }
}

export default useBreakpoints;